<template>
    <div class="row">
        <div class="mb-3 select-service-container">
            <select ref="input" class="form-control form-control-lg service-tom-selector" multiple
                    placeholder="Add a service">
            </select>
        </div>
    </div>
</template>

<script>

import TomSelect from 'tom-select'
import {getServices} from "../api";
import {EventBus} from "@/events/event-bus";

export default {

    name: "selectServicesDropdown",
    props: {
        from: {
          type: String,
          default: 'inquiry' // Set your default value here
        },
        currency: null,
        booking: null,
        parent: null,
        isMobile: false
    },
    data() {
        return {
            select: null,
            openOnFocus: true,
            services: [],
            categories: [],
            loadCounter: 0,
            general_assigned_products: '',
            isCustomId: null,
        }
    },
    computed: {
        customService() {
            return this.services.find(service => service.isCustom);
        },
        selectedServices(){
            return this.$parent.$parent.services
        }
    },
    methods: {
        reorderGroups() {
            this.$nextTick(function () {
            });
            this.categories = _.groupBy(this.services, item => item.categoryName.replace('_', ''))
            let categories = Object.keys(this.categories).sort((a, b) => a.localeCompare(b))
            this.select.clearOptions()
            this.select.addOptions(this.services)
            for (let category of categories) {
                this.select.addOptionGroup(category, {title: category})
            }
        },
        showAddServiceBTN: function (selected_count) {
            if (selected_count > 0) {
                this.$parent.showAddServiceButton = 1;
            } else {
                if ($("div[id^=service_checked_]").length == 1 && selected_count == 0) {
                    this.$parent.showAddServiceButton = 0;
                    this.$parent.showUpperSelectServiceInput = 0;
                } else {
                    this.$parent.showAddServiceButton = 1;
                }
            }
        },
        loadOptionsIntoSelect(businessType, callback) {
            let vm = this;
           if( typeof(this.booking) !== 'undefined' &&   typeof(this.booking.customers)  !== 'undefined' && this.booking.customers &&  this.booking.customers_counter >1 ){
                   var allow_multi_customers=1;
               }
            else {
               var allow_multi_customers=0;
           }

            getServices(businessType,allow_multi_customers)
                .then(response => {
                    if (response.data.length == 0) {
                        return null
                    }

                    this.services = _.map(response.data, (item) => {

                        if (typeof item != "object")
                            return null

                        let categoryName = item.category_name

                        if (!item.category_id) {
                            categoryName = "_Others";
                        } else {
                            categoryName = item.category_name
                        }

                        if (item.is_custom == 1) vm.isCustomId = item.service_id;

                        let serviceId = item.is_custom ? item.service_id : item.service_id + "-" + item.category_id

                        return {
                            categoryName,
                            categoryId: item.category_id ?? 0,
                            serviceId: serviceId,
                            serviceName: item.service_name,
                            minPrice: item.min_price,
                            is_free: item.is_free,
                            allow_multi_customers: item.allow_multi_customers,
                            default_follow_up_period: item.default_follow_up_period,
                            assigned_products: item.assigned_products,
                            isCustom: item.is_custom,
                        }
                    }).filter(item => item != null)

                    if (callback)
                        callback(this.services)
                    this.general_assigned_products = response.data.general_assigned_products;
                })


          EventBus.$on('onServiceRemoved', (serviceId, clone) => {
            this.select.clear();
          })

        },
        onFocusServicesDropDown() {
            try {
                this.select.on('focus', () => {
                    $(this.select.dropdown_content).parent().show()
                })
            } catch (e) {
                console.warn(e.message)
            }
        },
    },
    mounted() {
        let vm = this
        this.$nextTick(() => {
            // I added the variable to window to use it in jquery in other pages
            this.select = window.servicesSelect = new TomSelect(this.$refs['input'], {
                preload: false,
                labelField: 'serviceName',
                searchField: ['serviceName', 'categoryName'],
                searchConjunction: 'or',
                valueField: 'serviceId',
                optgroupValueField: 'categoryId',
                optgroupLabelField: 'categoryName',
                optgroupField: 'categoryName',
                dropdownParent: this.parent,
                closeAfterSelect: true,
                highlight: false,
                persist: false,
                hideSelected: false,
                duplicates: true,
                load: function (query, callback) {
                    vm.loadOptionsIntoSelect($('#business_address').val(), (data) => {
                        vm.reorderGroups();
                        callback(data)
                    });
                },

                openOnFocus: true,
                plugins: {
                    'dropdown_header': {
                        html() {
                            return `<div class="create_new_service_js">
                        <a href="/settings/services/add" class="create_new_service_js_link" target="_blank" style="color: #2E4051; text-decoration: none;padding: 7px 9px 3px 12px;">
                        <svg width="20" height="20" style="fill: #2E4051;" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#03A9F4"/>
                        </svg><span style="position: relative; top: -5px;left: 8px;">Create New Service</span></a>
                      </div>`
                        }
                    }
                },
                render: {
                    option: function (item, escape) {
                        // let display ="";Q
                        //  if (item.isCustom ==1  && item.enable ==1 ){ display = "none"; };
                        let display = item.isCustom ? "none" : "";
                        let multi_customers;
                         if(item && item.allow_multi_customers ){
                             multi_customers = "<span class='float-right m-l-sm'><i class='fa fa-users' aria-hidden='true'></i></span>";
                        }
                        else{
                             multi_customers = "";
                        }
                        let classCustom = item.isCustom ? "customService" : "sssssss";
                        /**  add class "customService" to HTML case company allow Custom service  **/
                        return `<div class="col-12 ${classCustom}" style="display:${display}">
                          <span class="float-start">${unescape(item.serviceName)}</span>
                          ${multi_customers}
                          <span class="float-right">${vm.currency}${item.minPrice}</span>
                        </div>`;
                    },
                    item: function (data, escape) {
                        return `<div style="height: 40px; display: none;" id="service_name_${data.serviceId}">${escape(data.serviceName)}</div>`;
                    },
                    optgroup_header: function (data, escape) {
                        return `<div class="font-bold optgroup-header" style="color: #0a0a0a">${data.title.replace('_', '')}</div>`;
                    }
                },
            })

            // This for input field icon
            let selectedCount = 0;
            let icon = $(`<svg width="20" height="15" class="add-menu-icon" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 10V8H7V10H0ZM0 6V4H11V6H0ZM0 2V0H11V2H0Z" fill="#2E4051"/>
                            <path d="M12.9854 14.0284L15.1005 14.0284L15.1005 10.1005H19.0284V7.98545H15.1005L15.1005 4.05752L12.9854 4.05752L12.9854 7.98545H9.05752V10.1005H12.9854L12.9854 14.0284Z" fill="#2E4051"/>
                        </svg>`)

            if ($('.select-service-container .ts-control').length == 1) {
                $('.select-service-container .ts-control:first').prepend(icon);
            } else if ($('.select-service-container .ts-control').length == 2) {
                $('.select-service-container .ts-control:last').prepend(icon);
            }

            this.select.on('load', (data) => {

                let addCustomServiceElement = '<a role="button" class="create_new_service_js_link onSelectCustomService" style="color: #2E4051; text-decoration: none;padding: 7px 9px 3px 12px;">' +
                    '<svg width="20" height="20" style="fill: #2E4051;" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#03A9F4"/>' +
                    '</svg>' +
                    '<span style="position: relative; top: -5px;left: 8px;">Add Custom Service </span>' +
                    '</a>';


            if (! $(".onSelectCustomService").length && this.isCustomId !=null){
                /**
                 *  this.isCustomId !=null ??? show "Add Custom Service"    when the company allows Custom Service flag
                 settings/service-services
                 **/
                let is_products = document.getElementById("isProducts")?document.getElementById("isProducts").value:false
                let booking_status = document.getElementById("bookingStatus")?document.getElementById("bookingStatus").value:false
                let for_products = (is_products && is_products===booking_status)

                if(!for_products){
                  $(".create_new_service_js").append(addCustomServiceElement);

                  $(".onSelectCustomService").on('click', function () {
                      EventBus.$emit('onServiceAdded', vm.customService)
                      vm.select.close();
                  })
                }
                }




                let no_services_found = document.getElementById('no_services_found');

                if (!no_services_found && !(this.services.length > 0) && $("#tomselect-4-ts-control").val() == '') {
                    /**  to show No Results if no services are found
                     * related files ?? SelectServices.vue **/
                    $(this.select.dropdown_content).parent().append(`<div role="listbox" tabindex="-1" class="ts-dropdown-content" id="no_services_found"><div class="no-results">No results found</div></div>`)
                } else {
                    if (no_services_found && (this.services.length >= 1)) {
                        /** no_services_found ????? to  remove   element  and "No results found" text  if it exist
                         *  (this.services.length >= 1)  ????? remove "No results found" text if found services
                         *   related files ?? SelectServices.vue **/
                        no_services_found.remove();

                    }
                }
                if (!(this.services.length > 0)) {
                    /**  to show dropdown list **/
                    $(this.select.dropdown_content).parent().show()
                }
            });

            this.select.on('change', (value, item) => {
                if (!value) return null;
                if (!item) return null;
                $('div[id^=service_name_]').css('display', 'none');
                this.select.blur();
                this.showAddServiceBTN(selectedCount)
                $('#services-modal-mobile-view').modal('hide')
            })

            this.select.on('focus', () => {
                $(".onSelectCustomService").remove();
                this.select.load(this.select.query)
                this.select.refreshItems();
                this.select.refreshOptions();
            })

            this.select.on('type', (str) => {
                let no_services_found = document.getElementById('no_services_found');
                if (no_services_found) {
                    no_services_found.remove();
                }
            })

            // Add service
            this.select.on('item_add', (value, item) => {

              let service;
              service = {...this.services.find(service => service.serviceId == value)} //Clone service
              service.serviceId = service.serviceId.split("-")[0]
              selectedCount++
              this.showAddServiceBTN(selectedCount)
              this.select.settings.placeholder = "Add another service";
              this.select.blur();
              $('#services-modal-mobile-view').modal('hide')
              EventBus.$emit('onServiceAdded', service)

            })

            // remove a service when unselect it from dropdown
            this.select.on('item_remove', (value, item) => {
                selectedCount--;
                this.showAddServiceBTN(0);
                EventBus.$emit('onServiceRemoved', value)
            })
        })

        EventBus.$on('onBusinessTypeChanged', business_type => {
            /** EventBus  ====== make component vue js call each other
             *   call event name ======onCustomerChanged
             *   customer >>>>>  callback value
             *   related files ?? SelectServices.vue
             *   **/
            if (business_type) {
                this.loadOptionsIntoSelect(business_type);
            }
        });
        this.onFocusServicesDropDown()

        $("#services-modal-mobile-view").on("shown.bs.modal", function () {
            $("#tomselect-4-ts-control").focus();
        });
    }
}
</script>

<style lang="scss" scoped>
@import "bootstrap/scss/bootstrap";
@import "tom-select/dist/css/tom-select.min.css";
@import "tom-select/dist/css/tom-select.bootstrap5.min.css";
</style>
<style scoped>
.create_new_service_js {
    padding: 7px 9px 3px 12px !important;
    border-bottom: 1px solid #E0E2E5;
}
</style>